/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';

const bubbleFadeInOut = keyframes`
  0%, 80%, 100% { box-shadow: 0 10px 0 -5px; }
  40%           { box-shadow: 0 10px 0 0; }
`;

const l4Rotate = keyframes`
  0%   { transform: rotate(0deg) scale(1); }
  15%  { transform: rotate(0deg) scale(1.14); }
  50%  { transform: rotate(90deg) scale(1); }
  75%  { transform: rotate(90deg) scale(1); }
  100% { transform: rotate(90deg) scale(1); }
`;

const l4Layer = keyframes`
  0%   { transform: rotate(0deg); }
  25%  { transform: rotate(var(--s, 30deg)); }
  45%  { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
`;

export default $ => css`
  div.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }
  div.fullscreen > div {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  div.loader-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  div.loader-container.centered {
    justify-content: center;
  }
  div.loader-container.centered > .children {
    padding-right: 4rem;
  }
  div.loader-container > div {
    margin-left: 1em;
  }

  /* ── Logo loader: l4 square animation, logo as front layer ── */
  .logo-loader {
    display: grid;
    animation: ${l4Rotate} 1.4s infinite ease-in-out;
  }

  /* Two backing squares stacked behind the logo */
  .logo-loader::before,
  .logo-loader::after {
    content: '';
    grid-area: 1/1;
    animation: ${l4Layer} 1.4s infinite ease-in-out;
  }
  .logo-loader::before {
    background: ${$.primaryMain};
    opacity: 0.5;
  }
  .logo-loader::after {
    background: ${$.secondaryMain ?? $.primaryLight ?? '#60B99A'};
    --s: 60deg;
    opacity: 0.4;
  }

  /* Logo SVG sits on top as the front face */
  .logo-loader > svg,
  .logo-loader > * {
    grid-area: 1/1;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  /* ── Dots loader — unchanged ── */
  .dots-loader,
  .dots-loader:before,
  .dots-loader:after {
    opacity: 0.7;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    animation-fill-mode: both;
    animation: ${bubbleFadeInOut} 1.3s infinite ease-in-out;
  }
  .dots-loader {
    top: -8px;
    color: ${$.primaryMain};
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }
  .dots-loader.white {
    color: ${$.white};
  }
  .dots-loader:before,
  .dots-loader:after {
    content: '';
    position: absolute;
    top: 0;
  }
  .dots-loader:before {
    left: -12px;
    animation-delay: -0.32s;
  }
  .dots-loader:after {
    left: 12px;
  }
`;
